import { render, staticRenderFns } from "./Wp_wx_public_regist.vue?vue&type=template&id=6e704c1f&scoped=true&"
import script from "./Wp_wx_public_regist.vue?vue&type=script&lang=js&"
export * from "./Wp_wx_public_regist.vue?vue&type=script&lang=js&"
import style0 from "./Wp_wx_public_regist.vue?vue&type=style&index=0&id=6e704c1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e704c1f",
  null
  
)

export default component.exports